import { MailTemplateVariable } from 'types';
import { Button, Stack } from 'react-bootstrap';

type Props = {
  variables: MailTemplateVariable[];
  onInsert: (value: string) => void;
  onInsertResetLink: () => void;
  disabled?: boolean;
};

export default function MailTemplateVariablesPanel( {variables, onInsert, onInsertResetLink, disabled} : Props) {
  return (
    <Stack direction="horizontal" gap={2} className="flex-wrap">
      {variables
        .filter(v => v.key !== 'ResetLink')
        .map(v => (
          <Button
            key={v.key}
            size="sm"
            variant="outline-secondary"
            disabled={disabled}
            onClick={() => onInsert(v.key)}
          >
            {v.label}
          </Button>
        ))}
      {variables.some(v => v.key === 'ResetLink') && (
        <Button
          size="sm"
          variant="outline-primary"
          disabled={disabled}
          onClick={onInsertResetLink}
        >
          Password Link
        </Button>
      )}
    </Stack>
  );
}

export function sanitizeMailPreviewHtml(html: string): string {
  if (!html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const links = doc.querySelectorAll('a');
  links.forEach(link => {
    const span = doc.createElement('span');
    span.innerHTML = link.innerHTML;
    span.className = 'mail-link-preview';
    link.replaceWith(span);
  });

  return doc.body.innerHTML;
}

